

































import Vue from "vue";
import Component from "vue-class-component";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner";

@Component({ name: "NotificationBar", components: { BaseSpinner, BaseButton, BaseAvatar } })
export default class NotificationBar extends Vue {
  public notification: NotificationData | null = null;

  public timeoutId: NodeJS.Timeout | number = 0;

  public spinnerKey: number = 0;

  public get position() {
    return this.notification?.position ?? "bottom";
  }

  public setTimeout(period: number) {
    typeof this.timeoutId === "number" ? clearTimeout(this.timeoutId) : clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(this.clearNotification, period);
  }

  public onButtonClick() {
    this.notification?.button?.cb && this.notification?.button?.cb();
    this.clearNotification();
  }

  public onNotificationClick() {
    this.notification?.onNotificationClick && this.notification?.onNotificationClick();
    this.clearNotification();
  }

  public async addNotification(notification: NotificationData) {
    this.clearNotification();
    await this.$nextTick();
    this.notification = notification;
    this.spinnerKey++;
    this.setTimeout(notification.timeout ?? 4000);
  }

  public clearNotification() {
    typeof this.timeoutId === "number" ? clearTimeout(this.timeoutId) : clearTimeout(this.timeoutId);
    this.notification = null;
    this.timeoutId = 0;
  }

  public mounted() {
    (window as any).emitter = emitter;
    emitter.on<any>(EVENTS.NOTIFICATION_SHOW, this.addNotification);
    emitter.on<any>(EVENTS.NOTIFICATION_HIDE, this.clearNotification);
  }
  public beforeDestroy() {
    emitter.off<any>(EVENTS.NOTIFICATION_SHOW, this.addNotification);
    emitter.off<any>(EVENTS.NOTIFICATION_HIDE, this.clearNotification);
  }
}
